import { render, staticRenderFns } from "./CreateBootcamp.vue?vue&type=template&id=90553fc6"
import script from "./CreateBootcamp.vue?vue&type=script&lang=js"
export * from "./CreateBootcamp.vue?vue&type=script&lang=js"
import style0 from "./CreateBootcamp.vue?vue&type=style&index=0&id=90553fc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports